import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { FormControlLabel, Checkbox } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import scan from "../../assets/scan.png";
import Button from "@mui/material/Button";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import file from "../../assets/file.png";
import "./ScanDevice.css";
import getCookie, { setAdminCookie } from "../../Atom";
import EditFile from "../LaunchtrakFligths/EditFile/EditFile";
import DialogTitle from "@mui/material/DialogTitle";
import { createNewLaunchTrek } from "../LaunchtrakFligths/api";
import DeleteFiles from "../dialogs/DeleteFiles";
export default function ScanDevice(props) {
  // const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("xs");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [fileName, setFileName] = React.useState("");
  const [deleteOpen, setDeleteOpen] = React.useState("");
  const [index, setIndex] = React.useState(0);

  const onCheckFiles = (item, index) => {
    const itemIndex = props?.checkedFiles.indexOf(item);
    let temp = [...props?.checkedFiles];
    let tempArr = [...props?.tempArray];
    if (itemIndex >= 0) {
      temp.splice(itemIndex, 1);
      tempArr.splice(itemIndex, 1);
      props?.setCheckedFiles(temp);
      props?.setTempArray(tempArr);
    } else {
      // Insert item at index
      temp[index] = item;
      tempArr.push(item);
      props?.setCheckedFiles(temp);
      props?.setTempArray(tempArr);
    }
  };
  const onCheckAllFiles = () => {
    if (props?.tempArray?.length === props?.fileNames?.length) {
      props?.setCheckedFiles([]);
      props?.setTempArray([]);
    } else {
      props?.setCheckedFiles(props?.fileNames);
      props?.setTempArray(props?.fileNames);
    }
  };
  const onClickScan = async () => {
    props?.setScanLoading(true);
    props?.getFilenames();
    await props?.delay(3000);
    // props?.setScanLoading(false);
    if (props?.fileNames?.length === 0) {
      props?.setNoFiles(true);
    }
    props?.setScanLoading(false);
  };
  const ondeleteAll = () => {
    setDeleteOpen(true);
  };

  const onEditFile = (item, index) => {
    setFileName(item);
    setIndex(index);
    props?.setMetaData({
      name: props?.metaArr[index]?.name || item,
      pressure: props?.metaArr[index]?.pressure,
      volumeOfWater: props?.metaArr[index]?.volumeOfWater,
      volumeOfEngine: props?.metaArr[index]?.volumeOfEngine,
      nozzleSize: props?.metaArr[index]?.nozzleSize,
      rocketDryMass: props?.metaArr[index]?.rocketDryMass,
      parachuteSize: props?.metaArr[index]?.parachuteSize,
      noParachut: props?.metaArr[index]?.noParachut,
    });
    setOpenEdit(true);
  };
  const handleClose = () => {
    props?.disconnectFromSerial();
    props?.setNoFiles(false);
    props?.setCheckedFiles([]);
    props?.setMetaArr([]);
    props?.setOpen(false);
    props?.setFileNames([]);
    props?.setScanLoading(false);
    props?.setTempArray([]);
    props?.setDeviceData([
      {
        name: "",
        pressure: 0,
        volumeOfWater: 0,
        volumeOfEngine: 0,
        nozzleSize: 0,
        rocketDryMass: 0,
        parachuteSize: 0,
        noParachut: false,
        decentSpeed: 0,
        topSpeed: 0,
        totalFlightTime: 0,
        apogeeAltitude: 0,
        apogeeTime: 0,
        coastTime: 0,
      },
    ]);
  };

  const uploadFiles = async () => {
    let newData = [];
    setLoading(true);
    for (let index = 0; index < props?.checkedFiles?.length; index++) {
      const element = props?.checkedFiles[index];
      if (element) {
        localStorage.setItem("filename", element);
        const data = await props?.viewFileData();

        // //pressure spike check
        // let filterdata = [];
        // if (data.graphData.length > 0) {
        //   filterdata = await filterPressureSpike(data.graphData);
        // }

        newData.push({
          metaData: { ...props?.metaArr[index] },
          originalName: element,
          valuesOfInterest: data?.valuesOfInterest,
          graphData: data?.graphData,
        });
      }
    }
    console.log("newData.........", newData);
    props?.setDeviceData(newData);

    const _cookie = getCookie("recoil-persist");
    if (_cookie) {
      const user = JSON.parse(_cookie)["KT_app"];
      const launchRes = await createNewLaunchTrek(newData, user?.token);
      if (launchRes?.res?.status === 200) {
        await props?.delay(1000);
        handleClose();
        props?.getLaunchData(
          user,
          props?.page,
          props?.pageLimit,
          "createdAt",
          "desc"
        );
        setLoading(false);
        props?.setSnackBarShow(true);
        props?.setSnackBarMessage("Files uploaded successfully");
        props?.setSnackBarSeverity("success");
        props?.setFileNames([]);
        props?.setMetaArr([]);
        props?.setCheckedFiles([]);
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={props?.open}
        // onClose={handleClose}
      >
        <DialogTitle></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading || props?.scanLoading}
          sx={{
            position: "absolute",
            pointerEvents: loading ? "none" : "auto",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <Box
            noValidate
            component="form"
            style={{ display: "flex", flexDirection: "column", gap: 30 }}
          >
            <Typography
              style={{
                color: "#000000",
                fontWeight: 500,
                fontSize: 24,
                fontFamily: "Inter",
                marginTop: "10px",
              }}
            >
              Your LaunchTrak has been connected successfully!{" "}
            </Typography>
            {props?.fileNames?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  disabled={loading}
                  control={
                    <Checkbox
                      checked={
                        props?.tempArray?.length === props?.fileNames?.length
                          ? true
                          : false
                      }
                      // onClick={editFeatured}
                      onClick={onCheckAllFiles}
                      style={{
                        color: "#0000004D",
                      }}
                    />
                  }
                  label={
                    <Typography
                      variant="subtitle1"
                      className="text-[#00000033]"
                      sx={{
                        fontWeight: 400,
                        fontSize: 19,
                        fontFamily: "Inter",
                      }}
                    >
                      Select all
                    </Typography>
                  }
                />
                <IconButton
                  onClick={ondeleteAll}
                  sx={{ pointerEvents: loading ? "none" : "auto" }}
                >
                  <DeleteOutlineIcon
                    sx={{
                      color: "#E80000",
                      cursor: "pointer",
                      pointerEvents: loading ? "none" : "auto",
                    }}
                  />
                </IconButton>
              </div>
            )}

            <div
              className={loading ? "blur-content" : "parent-container"}
              style={{
                backgroundColor: "#348BE31C",
                height: "500px",
                overflowY: "auto",
                padding: "20px",
                borderRadius: "16px 16px 16px 16px",
                display: "flex",
                justifyContent: props?.fileNames?.length <= 0 && "center",
              }}
            >
              {props?.noFiles && props?.fileNames?.length === 0 ? (
                <Typography className="align-self-center">
                  There are no files on the device.
                </Typography>
              ) : props?.fileNames?.length > 0 ? (
                <div style={{ width: "100%" }}>
                  {props?.fileNames?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div>
                          <FormControlLabel
                            disabled={loading}
                            control={
                              <Checkbox
                                checked={
                                  props?.checkedFiles?.includes(item)
                                    ? true
                                    : false
                                }
                                // onClick={() => loadData(item)}
                                onClick={() => onCheckFiles(item, index)}
                                style={{
                                  color: "#0000004D",
                                }}
                              />
                            }
                            label={
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: 5,
                                }}
                              >
                                <img
                                  src={file}
                                  alt="file"
                                  style={{ width: "22.77px" }}
                                />
                                <Typography
                                  variant="subtitle1"
                                  className="text-[#00000033]"
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: 19,
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {item}
                                </Typography>
                              </Box>
                            }
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "3px",
                          }}
                        >
                          {/* <DeleteOutlineIcon
                            sx={{
                              color: checkedFiles.includes(item)
                                ? "#000000B0"
                                : "gray",
                              cursor: checkedFiles.includes(item)
                                ? "pointer"
                                : "not-allowed",
                            }}
                            onClick={() => {
                              if (checkedFiles.includes(item)) {
                                ondeleteAll(item);
                              }
                            }}
                          /> */}
                          <EditIcon
                            sx={{
                              color: props?.checkedFiles.includes(item)
                                ? "#000000B0"
                                : "gray",
                              cursor: props?.checkedFiles.includes(item)
                                ? "pointer"
                                : "not-allowed",
                              pointerEvents: loading ? "none" : "auto",
                            }}
                            onClick={() => {
                              if (props?.checkedFiles.includes(item)) {
                                onEditFile(item, index);
                              }
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: 40,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <img
                      src={file}
                      style={{ width: "100px", height: "100px" }}
                      alt="file"
                    />
                  </div>
                  <Button
                    component="label"
                    disabled={loading || props?.scanLoading}
                    variant="contained"
                    sx={{
                      backgroundColor: "#348BE3",
                      width: 165,
                      height: 53,
                      textTransform: "none",
                      display: "flex",
                      flexDirection: "row !important",
                      alignItems: "center !important",
                      alignContent: "center",
                      justifyContent: "center",
                      justifyItems: "center",
                    }}
                    startIcon={
                      <img
                        src={scan}
                        style={{ width: 23, height: 23 }}
                        alt="file"
                      />
                    }
                    onClick={onClickScan}
                  >
                    Scan Device
                  </Button>
                </div>
              )}
            </div>
          </Box>
          {loading && (
            <Box
              display="flex"
              flexDirection="column"
              gap={3}
              justifyContent="center"
              alignItems="center"
              className="loading-overlay"
            >
              {" "}
              <Typography>Saving the files, this may take a while</Typography>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            component="label"
            variant="contained"
            disabled={props?.checkedFiles?.length && !loading ? false : true}
            sx={{
              backgroundColor: "#348BE3",
              width: 223,
              height: 55,
              textTransform: "none",
              display: "flex",
              flexDirection: "row !important",
              alignItems: "center !important",
              alignContent: "center",
              justifyContent: "center",
              justifyItems: "center",
              marginRight: 2,
            }}
            startIcon={<FileUploadOutlinedIcon />}
            onClick={uploadFiles}
          >
            Upload & Save
          </Button>
        </DialogActions>
      </Dialog>
      <EditFile
        fileName={fileName}
        deviceData={props?.deviceData}
        setDeviceData={props?.setDeviceData}
        index={index}
        metaArr={props?.metaArr}
        setMetaArr={props?.setMetaArr}
        open={openEdit}
        setOpen={setOpenEdit}
        setMetaData={props?.setMetaData}
        metaData={props?.metaData}
        setSnackBarShow={props?.setSnackBarShow}
        setSnackBarMessage={props?.setSnackBarMessage}
        setSnackBarSeverity={props?.setSnackBarSeverity}
      />
      <DeleteFiles
        open={deleteOpen}
        setOpen={setDeleteOpen}
        setSnackBarShow={props?.setSnackBarShow}
        setSnackBarMessage={props?.setSnackBarMessage}
        setSnackBarSeverity={props?.setSnackBarSeverity}
        deleteFilesFromDevice={props?.deleteFilesFromDevice}
        handleClose={handleClose}
        setCheckedFiles={props?.setCheckedFiles}
        moduleDel="deleteFromDevice"
      />
    </React.Fragment>
  );
}
